
import $global from 'stores/global'
import {Later} from 'utils/timers'
import {ITEMS} from './navbar-items.js'
import $profile from 'stores/profile'
import MenuCollapsed from './menu-collapsed.vue'
import MenuExpanded from './menu-expanded.vue'

export default {
  components: {MenuCollapsed, MenuExpanded},
  setup(){
    return {
      n_items: ITEMS,
    }
  },
  data(){
    return {
      open: this.$responsive.desktop && $global.nav_pinned,
      expand: new Later(200),
      allows: new Set(),
    }
  },
  computed: {
    overlay() {
      return !this.$responsive.desktop && !this.$responsive.mobile
    },
    pinned: {
      get(){
        return !this.overlay && $global.nav_pinned
      },
      set(val){
        $global.nav_pinned = val
      }
    },
    collapsed() {
      return !this.open
    },
    can_collapse() {
      return !this.allows.size
    },
    items () {
      return this.n_items.filter(item => {
        if (item.admin_only || item.tenant_manager_only) {
          return (item.admin_only && $profile.is_admin) ||
                 (item.tenant_manager_only && $profile.is_tenant_manager)
        }
        return !item.superuser || $profile.is_admin
      })
    },
  },
  watch: {
    overlay() {
      this.expand.abort()
      this.open = this.pinned
    },
    '$route.fullPath'() {
      if (this.overlay) this.close()
    },
    pinned(val) {
      this.expand.abort()
      if (val) this.open = true
    },
    can_collapse(val) {
      if (val) {
        const hovered = Array.from(document.querySelectorAll(':hover'))
        if (!hovered.includes(this.$el)) {
          this.onMouseLeave()
        }
      }
    }
  },
  beforeUnmount() {
    this.expand.abort()
  },
  methods: {
    close() {
      this.expand.abort()
      this.open = false
    },
    toggleBurger() {
      this.expand.abort()
      this.open = !this.open
    },
    onMouseEnter() {
      this.expand.abort()
      if (this.overlay || this.pinned) return

      this.expand.once(() => {
        this.open = true
      })
    },
    onMouseLeave() {
      this.expand.abort()
      if (this.overlay || !this.can_collapse || this.pinned) return

      this.expand.once(() => {
        this.open = false
      })
    },
    allowCollapse(ev){
      ev.show ? this.allows.add(ev.id) : this.allows.delete(ev.id)
    },
  }
}
